import axios from 'axios';
import { FormData } from '../types/form';

type LeadRegisterResult = {
    status: 'success' | 'error';
    data: unknown;
    fieldErrors?: { [field: string]: string };
};

const extractFieldErrors = (error: unknown): { [field: string]: string } | undefined => {
    if (!axios.isAxiosError(error) || error.response?.status !== 422) {
        return undefined;
    }

    const errors = error.response.data?.errors;

    if (!errors || typeof errors !== 'object') {
        return undefined;
    }

    const fieldErrors: { [field: string]: string } = {};

    Object.keys(errors).forEach((field) => {
        const message = Array.isArray(errors[field]) ? errors[field][0] : errors[field];

        if (typeof message === 'string') {
            fieldErrors[field] = message;
        }
    });

    return Object.keys(fieldErrors).length > 0 ? fieldErrors : undefined;
};

const responseConfig = {
    headers: {
        'Authorization': 'Bearer ' + process.env.REACT_APP_V3_API_TOKEN
    }
};

export const registerLead = async (values: FormData): Promise<LeadRegisterResult> => {

	try {
        const registerUrl = process.env.REACT_APP_V3_URL + '/leads/register';
        const response = await axios.post(registerUrl, values, responseConfig);
        
        if (response.status >= 200 && response.status <= 201) {
            return { status: 'success', data: response.data };
        } else {
	        return { status: 'error', data: response.data };
        }
    } catch (error) {
        if (error instanceof Error) {
            console.error(error.message);
        } else {
            console.error(error);
        }
		
        return { status: 'error', data: error, fieldErrors: extractFieldErrors(error) };
    }
};
